import type { ReactNode } from 'react';

import { Card, CardContent } from '@/components/ui/card';

interface TableCardProps {
  children: ReactNode;
  className?: string;
}

export function TableCard({ children, className }: TableCardProps): JSX.Element {
  return (
    <Card className={className}>
      <CardContent className="p-0">
        {children}
      </CardContent>
    </Card>
  );
}
